export default {"src":"/_next/static/media/menu-share-icon.183919ea.svg","height":14,"width":14};